import { Card } from "@/components/portal/ui";

const SNAP_TONE = { "Stable": "bg-[#667A66]/12 text-[#4d6b4d]", "Variable": "bg-[#9F634E]/12 text-[#9F634E]",
  "Needs Review": "bg-[#C49A5A]/15 text-[#8a6a2e]", "Priority Area": "bg-[#9E4F4F]/12 text-[#9E4F4F]" };

const SECTION_ORDER = {
  diagnostic: [
    ["current_sleep_picture", "Current Sleep Picture"], ["last_night_timeline", "Last-Night Timeline"],
    ["top_priority_areas", "Top Priority Areas"], ["what_appears_connected", "What Appears Connected"],
    ["what_may_not_need_changing", "What May Not Need Changing Yet"], ["professional_observations", "Professional Observations"],
    ["what_to_address_first", "What to Address First"], ["next_step_options", "Next-Step Options"],
  ],
  blueprint: [
    ["current_sleep_picture", "Current Sleep Picture"], ["goals", "Goals"],
    ["daily_rhythm", "Personalized Daily Rhythm"], ["wake_guidance", "Wake Period Guidance"],
    ["nap_strategy", "Nap Plan"], ["bedtime_plan", "Bedtime Plan"], ["settling_strategy", "Settling Strategy"],
    ["night_waking_plan", "Night-Waking Strategy"], ["implementation_sequence", "Sequence of Changes"],
    ["days_1_3", "Days 1–3"], ["days_4_7", "Days 4–7"], ["monitor", "What to Watch"],
    ["troubleshooting", "Troubleshooting"], ["stay_consistent", "When to Stay Consistent"],
    ["when_adjust", "When to Adjust"], ["when_ask_help", "When to Ask for Help"],
    ["change_first", "What to Change First"], ["leave_alone", "What to Leave Alone"], ["custom_notes", "Custom Notes"],
  ],
  inhome_overnight: [
    ["overnight_observations", "Overnight Observations"], ["morning_debrief", "Morning Debrief"],
    ["recommended_adjustments", "Recommended Adjustments"], ["followup_summary", "Follow-Up Summary"],
    ["next_steps", "Next-Step Guidance"],
  ],
};

export default function Deliverable({ report, product }) {
  const order = SECTION_ORDER[product] || [];
  return (
    <div className="space-y-6">
      {report.snapshot?.length > 0 && (
        <Card className="p-6">
          <div className="eyebrow text-[#8A998C] mb-4">Sleep Pattern Snapshot</div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {report.snapshot.map((s) => (
              <div key={s.category} className="flex items-center justify-between border border-[#E5E1D8] rounded-lg px-4 py-3">
                <span className="text-[#1A1918] text-sm">{s.category}</span>
                <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${SNAP_TONE[s.status] || "bg-[#E5E1D8] text-[#6B665E]"}`}>{s.status}</span>
              </div>
            ))}
          </div>
        </Card>
      )}
      {order.map(([k, label]) => report.sections?.[k] && (
        <Card key={k} className="p-6">
          <div className="eyebrow text-[#9F634E] mb-3">{label}</div>
          <p className="text-[#1A1918] text-[15px] leading-[1.8] whitespace-pre-wrap">{report.sections[k]}</p>
        </Card>
      ))}
      <p className="text-xs text-[#8A998C] px-1">Prepared and approved by your qualified consultant. This is professional sleep guidance, not medical care.</p>
    </div>
  );
}
